import { FC } from 'react';

import { Button } from '@/Components/Button';
import { ExclamationSvg } from '@/Components/Icons/ExclamationSvg';
import { FlickAnimation } from '@/Components/FlickAnimation';
import { ModalView } from '@/Components/ModalView';
import { AppModalProps } from '@/types/modal.type';
import { useDeleteReel } from '@/Pages/Library/hook/useDeleteReel';
import { useInteractiveCallback } from '@/hook/useInteractiveCallback';

type DeleteReelUnpublishedModalProps = AppModalProps<{
    reelId: number;
    reelName: string;
    onReview: () => void;
    onDeleteClick: () => void;
}>;

export const DeleteReelUnpublishedModal: FC<
    DeleteReelUnpublishedModalProps
> = ({ payload, onClose }) => {
    const { deleteReel } = useDeleteReel();

    const onDelete = useInteractiveCallback(() => {
        onClose();

        deleteReel(payload.reelId, payload.reelName);

        payload?.onDeleteClick?.();
    });

    const onReview = useInteractiveCallback(() => {
        onClose();

        payload.onReview();
    });

    return (
        <ModalView
            maxWidth="sm"
            onClose={onClose}
            contentContainerClassName="py-6 px-8 text-brand-ocean flex flex-col justify-center items-center">
            <div className="relative min-w-60 h-24 flex items-center justify-center">
                <FlickAnimation className="absolute z-10 bottom-5 left-11" />
                <div className="absolute bottom-5 right-20">
                    <ExclamationSvg className="[&_path]:fill-orange-500" />
                </div>
            </div>
            <p className="w-full text-heading-five font-bold text-brand-ocean mb-2 mt-2">
                Video reel is in unpublished Flows
            </p>
            <div className="w-full text-body-text-15 text-left text-brand-ocean mb-4">
                Deleting "{payload.reelName}" will remove it from all of them.
            </div>
            <div className="mt-2 w-full flex flex-col items-center justify-center gap-2">
                <Button
                    className="w-full h-9"
                    variant="danger"
                    onClick={onDelete}>
                    Delete Video Reel
                </Button>
                <Button
                    className="w-full h-9"
                    variant="default"
                    onClick={onReview}>
                    Review linked Flows
                </Button>
                <Button
                    className="w-full h-9"
                    variant="default"
                    onClick={onClose}>
                    Cancel
                </Button>
            </div>
        </ModalView>
    );
};
